var blockquote_default = {
  "fontElementMap": "_1AY47",
  "quote": "aJlMH"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
